export default __webpack_public_path__ + "static/fin-ins-claims-e9cdc993839f91d317db0dddd27312c1.png";